module.exports = __webpack_public_path__ + "static/img/fish33.366ccfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish33.png
// module id = S5Vs
// module chunks = 0